<style scoped>
.font-normal{
  font-weight: normal;;
}
.f-weight{
  font-weight: bold;;
}
.bank-item:first-child{
  margin-right: 10px;
}
.txt-right {
  text-align: right;
}

.page-title-txt {
  font-size: 14px;
  font-weight: 600;
  text-align: left;
}
table {
  border-color: #bcbcbc;
  border-spacing: 0px;
  line-height: 30px;
  width: 100%;
  border-top: none;
  border-left: none;
  text-align: left;
}
table tr td,
.tdBg {
  /* border-bottom: none; */
  /* border-right: none; */
  border-color: #bcbcbc;
  padding: 0 6px;
}
.tdBg {
  background: #f3f3f3;
}
.tdCenter {
  text-align: center;
  border-right: none;
}
.page-write {
  text-align: left;
  padding: 106px 0;
  box-sizing: border-box;
  font-weight: bold;
}
.page-title{
  padding-top:30px;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 0;
}
</style>
<template>
  <div class="printPage">
    <el-dialog
      title="打印预览"
      :visible.sync="showPrintDialog"
      width="900px"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <div v-if="printType==0" :id="'printBillxx'+printType" style="padding: 0 30px;">
        <h1 id="myprinttd"  class="page-title">{{printData.taskType}}结算单</h1>
        <p class="page-title-txt" style="margin:0;padding-top: 16px;">尊敬的客户：</p>
        <p class="page-title-txt mb15">
          根据贵公司与我司所签订的服务协议，请贵公司确认以下费用明细，并进行相关款项支付，谢谢
        </p>
        <p class="txt-right">结算时间：{{ extradata.settleDate | getDate }}</p>
        <table border="1" class="mb30" style="width:100%">
          <tr>
            <td colspan="2" class="tdBg tdCenter" style="font-weight: 600;">本期应付款总结算明细</td>
          </tr>
          <tr>
            <td class="tdBg" width="255">本期应付款合计金额（小写）：</td>
            <td class="t-right">{{ printData.totalAmount|adjustFilter(printData.mantissaAmount,printData.approveState) | numFmt | numDigit}}</td>
          </tr>
          <tr>
            <td class="tdBg"  width="255">本期应付款合计（大写）：</td>
            <td class="t-right">{{ printData.totalAmount|adjustFilter(printData.mantissaAmount,printData.approveState) | smallToBig }}</td>
          </tr>
        </table>
        <table border="1px" class="mb30" style="width:100%">
          <tr class="t-center">
            <th class="tdBg" width="60">序号</th>
            <th class="tdBg" width="120">结算内容</th>
            <th class="tdBg" width="120">结算结果	</th>
            <th class="tdBg" >结果说明</th>
          </tr>
          <tr>
            <td class="t-center">1</td>
            <td class="t-right">结算金额(元)</td>
            <td class="t-right">{{ printData.realSettleMoney | numFmt | numDigit }}</td>
            <td class="t-left">个人结算明细表</td>
          </tr>

          <tr>
            <td class="t-center">2</td>
            <td class="t-right">结算人数(个)</td>
            <td class="t-right">{{ printData.personNum }}</td>
            <td class="t-left">详见结算明细表</td>
          </tr>

          <tr>
            <td class="t-center">3</td>
            <td class="t-right">服务费(元)</td>
            <td class="t-right">{{ printData.serviceAmount| numFmt | numDigit  }}</td>
            <td class="t-left">服务费费率，{{ printData.cooperationTaxRate + '%' }}</td>
          </tr>
          <tr>
            <td class="t-center">4</td>
            <td class="t-right">尾数调整(元)</td>
            <td class="t-right">{{ printData.mantissaAmount| numFmt | numDigit  }}</td>
            <td class="t-left"></td>
          </tr>
          <tr>
            <td class="t-center">5</td>
            <td class="t-right">结算总额(元)	</td>
            <td class="t-right">{{ printData.totalAmount|adjustFilter(printData.mantissaAmount,printData.approveState)| numFmt | numDigit  }}</td>
            <td class="t-left">结算金额+服务费金额+尾数调整</td>
          </tr>
      
        </table>
        <div  style="width:100%;display:flex;">
          <div style="flex:1;margin-right: 10px;">
            <p class="page-title-txt mb15">贵公司账户信息如下：</p>
            <table border="1px" class="mb15">
              <tr>
                <td class="tdBg" width="100">开户名称：</td>
                <td class="t-left">{{printData.serviceTenantContractBank&&printData.serviceTenantContractBank.tenantName || '-' }}</td>
              </tr>
           
              <tr>
                <td class="tdBg" width="100">开户银行：</td>
                <td class="t-left" style="height:40px;line-height: 20px;">{{printData.serviceTenantContractBank&&printData.serviceTenantContractBank.bankName}}</td>
              </tr>
              <tr>
                <td class="tdBg" width="100">银行账号：</td>
                <td class="t-left">{{printData.serviceTenantContractBank&&printData.serviceTenantContractBank.bankAccount}}</td>
              </tr>
              <tr>
                <td class="tdBg" width="100">公司税号：</td>
                <td class="t-left">{{printData.serviceTenantContractBank&&printData.serviceTenantContractBank.bankTaxNo || '-' }}</td>
              </tr>
              <tr>
                <td class="tdBg" width="100">公司电话：</td>
                <td class="t-left">{{printData.serviceTenantContractBank&&printData.serviceTenantContractBank.tel || '-' }}</td>
              </tr>
              <tr>
                <td class="tdBg" width="100">公司地址：</td>
                <td class="t-left" style="height:40px;line-height: 20px;">{{printData.serviceTenantContractBank&&printData.serviceTenantContractBank.address || '-' }}</td>
              </tr>
            </table>
            <div class="t-left f-weight" style="padding:20px 0 20px 0;">贵公司对接人：<span class="font-normal">{{printData.serviceTenantContacts}}</span></div>
            <div class="t-left  f-weight">我司对接人：<span class="font-normal">{{printData.tenantContacts}}</span></div>
            <div class="page-write" style="padding-top:26px">盖章处</div>
          </div>
          <div style="flex:1;">
            <p class="page-title-txt mb15">我方账户信息如下：</p>
            <table border="1px" class="mb15">
              <tr>
                <td class="tdBg" width="100">开户名称：</td>
                <td class="t-left">{{printData.tenantContractBank&&printData.tenantContractBank.tenantName || '-' }}</td>
              </tr>
           
              <tr>
                <td class="tdBg" width="100">开户银行：</td>
                <td class="t-left" style="height:40px;line-height: 20px;">{{printData.tenantContractBank&&printData.tenantContractBank.bankName}}</td>
              </tr>
              <tr>
                <td class="tdBg" width="100">银行账号：</td>
                <td class="t-left">{{printData.tenantContractBank&&printData.tenantContractBank.bankAccount}}</td>
              </tr>
              <tr>
                <td class="tdBg" width="100">公司税号：</td>
                <td class="t-left">{{printData.tenantContractBank&&printData.tenantContractBank.bankTaxNo || '-' }}</td>
              </tr>
              <tr>
                <td class="tdBg" width="100">公司电话：</td>
                <td class="t-left">{{printData.tenantContractBank&&printData.tenantContractBank.tel || '-' }}</td>
              </tr>
              <tr>
                <td class="tdBg" width="100">公司地址：</td>
                <td class="t-left" style="height:40px;line-height: 20px;">{{printData.tenantContractBank&&printData.tenantContractBank.address || '-' }}</td>
              </tr>
            </table>
            <div class="page-write">盖章处</div>
          </div>
        </div>
      </div>
      <div v-if="printType==1" :id="'printBillxx'+printType" style="margin: 0 30px;">
        <table border="1" class="mb30" style="width:100%">
          <tr>
            <td colspan="8" class="tdBg tdCenter">附件：{{ printData.taskType }}</td>
          </tr>
          <tr class="tdBg t-center">
            <td width="60">序号</td>
            <td width="60">姓名</td>
            <td width="170">身份证号码</td>
            <td width="170"> 银行卡号</td>
            <td width="100">手机号</td>
            <!-- <td width="200">任务类型</td> -->
            <td width="90">结算金额</td>
            <td width="100">结算时间</td>
          </tr>
          <tr  class="t-center"  v-for="(row, j) in printData.settleDetails" :key="j">
            <td >{{ j + 1 }}</td>
            <td class="t-left">{{ row.staffName }}</td>
            <td class="t-left">{{ row.idCode || '-' }}</td>
            <td class="t-left">{{ row.bankAccount || '-' }}</td>
            <td class="t-left">{{ row.mobileNo || '-' }}</td>
            <!-- <td class="t-left">{{ row.taskContent || '-' }}</td> -->
            <td class="t-right">{{ row.actualSettleMoney | numFmt | numDigit }}</td>
            <td class="t-left">{{ row.settleDate | getDate }}</td>
          </tr>
        </table>
        <div class="flex-between"  style="width:800px;position: relative;padding-bottom: 20px;">
            <div style="font-weight: bold;position: absolute;right: 130px;">盖章处</div>
        </div>
      </div>

      <!-- 二合一打印 -->
      <div
        v-if="printType == 2"
        :id="'printBillxx' + printType"
        style="padding: 0 30px"
      >
        <!-- 结算单部分 -->
        <h1 id="myprinttd" class="page-title">
          {{ printData.taskType }}结算单
        </h1>
        <p class="page-title-txt" style="margin: 0; padding-top: 16px">
          尊敬的客户：
        </p>
        <p class="page-title-txt mb15">
          根据贵公司与我司所签订的服务协议，请贵公司确认以下费用明细，并进行相关款项支付，谢谢
        </p>
        <p class="txt-right">结算时间：{{ extradata.settleDate | getDate }}</p>
        <table border="1" class="mb30" style="width: 100%">
          <tr>
            <td colspan="2" class="tdBg tdCenter" style="font-weight: 600">
              本期应付款总结算明细
            </td>
          </tr>
          <tr>
            <td class="tdBg" width="255">本期应付款合计金额（小写）：</td>
            <td class="t-right">
              {{
                printData.totalAmount
                  | adjustFilter(
                    printData.mantissaAmount,
                    printData.approveState
                  )
                  | numFmt
                  | numDigit
              }}
            </td>
          </tr>
          <tr>
            <td class="tdBg" width="255">本期应付款合计（大写）：</td>
            <td class="t-right">
              {{
                printData.totalAmount
                  | adjustFilter(
                    printData.mantissaAmount,
                    printData.approveState
                  )
                  | smallToBig
              }}
            </td>
          </tr>
        </table>
        <table border="1px" class="mb30" style="width: 100%">
          <tr class="t-center">
            <th class="tdBg" width="60">序号</th>
            <th class="tdBg" width="120">结算内容</th>
            <th class="tdBg" width="120">结算结果</th>
            <th class="tdBg">结果说明</th>
          </tr>
          <tr>
            <td class="t-center">1</td>
            <td class="t-right">结算金额(元)</td>
            <td class="t-right">
              {{ printData.realSettleMoney | numFmt | numDigit }}
            </td>
            <td class="t-left">个人结算明细表</td>
          </tr>

          <tr>
            <td class="t-center">2</td>
            <td class="t-right">结算人数(个)</td>
            <td class="t-right">{{ printData.personNum }}</td>
            <td class="t-left">详见结算明细表</td>
          </tr>

          <tr>
            <td class="t-center">3</td>
            <td class="t-right">服务费(元)</td>
            <td class="t-right">
              {{ printData.serviceAmount | numFmt | numDigit }}
            </td>
            <td class="t-left">
              服务费费率，{{ printData.cooperationTaxRate + "%" }}
            </td>
          </tr>
          <tr>
            <td class="t-center">4</td>
            <td class="t-right">尾数调整(元)</td>
            <td class="t-right">
              {{ printData.mantissaAmount | numFmt | numDigit }}
            </td>
            <td class="t-left"></td>
          </tr>
          <tr>
            <td class="t-center">5</td>
            <td class="t-right">结算总额(元)</td>
            <td class="t-right">
              {{
                printData.totalAmount
                  | adjustFilter(
                    printData.mantissaAmount,
                    printData.approveState
                  )
                  | numFmt
                  | numDigit
              }}
            </td>
            <td class="t-left">结算金额+服务费金额+尾数调整</td>
          </tr>
        </table>
        <div style="width: 100%; display: flex">
          <div style="flex: 1; margin-right: 10px">
            <p class="page-title-txt mb15">贵公司账户信息如下：</p>
            <table border="1px" class="mb15">
              <tr>
                <td class="tdBg" width="100">开户名称：</td>
                <td class="t-left">
                  {{
                    (printData.serviceTenantContractBank &&
                      printData.serviceTenantContractBank.tenantName) ||
                    "-"
                  }}
                </td>
              </tr>

              <tr>
                <td class="tdBg" width="100">开户银行：</td>
                <td class="t-left" style="height: 40px; line-height: 20px">
                  {{
                    printData.serviceTenantContractBank &&
                    printData.serviceTenantContractBank.bankName
                  }}
                </td>
              </tr>
              <tr>
                <td class="tdBg" width="100">银行账号：</td>
                <td class="t-left">
                  {{
                    printData.serviceTenantContractBank &&
                    printData.serviceTenantContractBank.bankAccount
                  }}
                </td>
              </tr>
              <tr>
                <td class="tdBg" width="100">公司税号：</td>
                <td class="t-left">
                  {{
                    (printData.serviceTenantContractBank &&
                      printData.serviceTenantContractBank.bankTaxNo) ||
                    "-"
                  }}
                </td>
              </tr>
              <tr>
                <td class="tdBg" width="100">公司电话：</td>
                <td class="t-left">
                  {{
                    (printData.serviceTenantContractBank &&
                      printData.serviceTenantContractBank.tel) ||
                    "-"
                  }}
                </td>
              </tr>
              <tr>
                <td class="tdBg" width="100">公司地址：</td>
                <td class="t-left" style="height: 40px; line-height: 20px">
                  {{
                    (printData.serviceTenantContractBank &&
                      printData.serviceTenantContractBank.address) ||
                    "-"
                  }}
                </td>
              </tr>
            </table>
            <div class="t-left f-weight" style="padding: 20px 0 20px 0">
              贵公司对接人：<span class="font-normal">{{
                printData.serviceTenantContacts
              }}</span>
            </div>
            <div class="t-left f-weight">
              我司对接人：<span class="font-normal">{{
                printData.tenantContacts
              }}</span>
            </div>
            <div class="page-write" style="padding-top: 26px">盖章处</div>
          </div>
          <div style="flex: 1">
            <p class="page-title-txt mb15">我方账户信息如下：</p>
            <table border="1px" class="mb15">
              <tr>
                <td class="tdBg" width="100">开户名称：</td>
                <td class="t-left">
                  {{
                    (printData.tenantContractBank &&
                      printData.tenantContractBank.tenantName) ||
                    "-"
                  }}
                </td>
              </tr>

              <tr>
                <td class="tdBg" width="100">开户银行：</td>
                <td class="t-left" style="height: 40px; line-height: 20px">
                  {{
                    printData.tenantContractBank &&
                    printData.tenantContractBank.bankName
                  }}
                </td>
              </tr>
              <tr>
                <td class="tdBg" width="100">银行账号：</td>
                <td class="t-left">
                  {{
                    printData.tenantContractBank &&
                    printData.tenantContractBank.bankAccount
                  }}
                </td>
              </tr>
              <tr>
                <td class="tdBg" width="100">公司税号：</td>
                <td class="t-left">
                  {{
                    (printData.tenantContractBank &&
                      printData.tenantContractBank.bankTaxNo) ||
                    "-"
                  }}
                </td>
              </tr>
              <tr>
                <td class="tdBg" width="100">公司电话：</td>
                <td class="t-left">
                  {{
                    (printData.tenantContractBank &&
                      printData.tenantContractBank.tel) ||
                    "-"
                  }}
                </td>
              </tr>
              <tr>
                <td class="tdBg" width="100">公司地址：</td>
                <td class="t-left" style="height: 40px; line-height: 20px">
                  {{
                    (printData.tenantContractBank &&
                      printData.tenantContractBank.address) ||
                    "-"
                  }}
                </td>
              </tr>
            </table>
            <div class="page-write">盖章处</div>
          </div>
        </div>

        <!-- 附件部分 -->
        <div style="page-break-before: always; margin-top: 40px">
          <table border="1" class="mb30" style="width: 100%">
            <tr>
              <td colspan="8" class="tdBg tdCenter">
                附件：{{ printData.taskType }}
              </td>
            </tr>
            <tr class="tdBg t-center">
              <td width="60">序号</td>
              <td width="60">姓名</td>
              <td width="170">身份证号码</td>
              <td width="170">银行卡号</td>
              <td width="100">手机号</td>
              <!-- <td width="200">任务类型</td> -->
              <td width="90">结算金额</td>
              <td width="100">结算时间</td>
            </tr>
            <tr
              class="t-center"
              v-for="(row, j) in printData.settleDetails"
              :key="j"
            >
              <td>{{ j + 1 }}</td>
              <td class="t-left">{{ row.staffName }}</td>
              <td class="t-left">{{ row.idCode || "-" }}</td>
              <td class="t-left">{{ row.bankAccount || "-" }}</td>
              <td class="t-left">{{ row.mobileNo || "-" }}</td>
              <!-- <td class="t-left">{{ row.taskContent || '-' }}</td> -->
              <td class="t-right">
                {{ row.actualSettleMoney | numFmt | numDigit }}
              </td>
              <td class="t-left">{{ row.settleDate | getDate }}</td>
            </tr>
          </table>
          <div
            class="flex-between"
            style="width: 800px; position: relative; padding-bottom: 20px"
          >
            <div style="font-weight: bold; position: absolute; right: 130px">
              盖章处
            </div>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closePrint" style="color: #4fa1a4">取 消</el-button>
        <el-button size="small" type="primary" @click="billPrintClick" style="color: #fff">打 印</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// import print from 'print-js';
import printJS from '../../../../assets/js/print.min.js'
import { saveAs } from 'file-saver';
import htmlDocx from 'html-docx-js/dist/html-docx';
export default {
  name: 'printPage',
  props: {
    showPrintDialog: {
      type: Boolean,
      default: false,
    },
    printType: {
      //内容类型
      type: Number,
      default: 1,
    },
    printData: {
      //内容
      type: Object,
      default: {},
    },
    
    extradata: {
      //内容
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      sendCopy: '',
      staffName:null
    };
  },
  filters: {
      adjustFilter(value,amount,state) {
        let num = Number(value)
        console.log('value',value,amount,state);
        if(state=='N'&&!isNaN(amount)){
            num=Number(value) + Number(amount)
        }
        
        return num
      }
      // adjustFilter(value,amount,list,state) {
      //   let num = Number(value)
      //   if(state=='N'){//草稿中的状态才需要加尾数调整
      //       if(list&&list.length>0){//结算单信息里的结算总额
      //           list.forEach(item=>{
      //               console.log('/',item.mantissaAmount);
      //               let mantissaAmount=Number(item.mantissaAmount)
      //               if(mantissaAmount&&!isNaN(item.mantissaAmount)){
      //                   console.log('p',mantissaAmount);
      //                   num += mantissaAmount
      //               }
      //           })
      //       }else{
      //           if(!isNaN(amount)){
      //               num=Number(value) +Number(amount)
      //           }
      //       }
      //       console.log('value',value,amount,list);
      //   }
      //   return num
      // }
    },
  created() {
    let userInfo = JSON.parse(localStorage.userInfo);
    this.staffName = userInfo.staffName;
  },
  methods: {
    fmoney(num) {
      if (!num) {
        return '0.00';
      }
      num = num.toString().replace(/\$|\,/g, '');
      if (isNaN(num)) num = '0';
      var sign = num == (num = Math.abs(num));
      num = Math.floor(num * 100 + 0.50000000001);
      var cents = num % 100;
      num = Math.floor(num / 100).toString();
      if (cents < 10) cents = '0' + cents;
      for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
        num = num.substring(0, num.length - (4 * i + 3)) + ',' + num.substring(num.length - (4 * i + 3));
      return (sign ? '' : '-') + num + '.' + cents;
    },
    getAmount(res) {
      if (!res) return '-';
      var list = [];
      var res = JSON.parse(res);
      res.forEach((item, index) => {
        list.push(`${item.costTypeName}${this.fmoney(item.costAmount)}元`);
      });
      return list.join('、');
    },
    getGoodsName(res) {
      if (!res) return;
      var list = [];
      var res = JSON.parse(res);
      res.forEach((item, index) => {
        list.push(`${item.name}<span style="color:#9F9F9F;font-size:14px !important;">(${item.goodsSpec})</span>`);
      });
      return list.join('、');
    },
    getDocorName(res) {
      if (!res) return;
      if (res.indexOf('name') > -1) {
        var list = [];
        var res = JSON.parse(res);
        if (res.length >= 2) {
          res.forEach((item, index) => {
            list.push(item.name);
          });
          return list.join('、');
        } else {
          return res[0].name;
        }
      } else {
        return res;
      }
    },
    // 导出 word 文档
    exportDocx() {
      let arr = document.querySelector('#printBill'); //获取dom
      let html = arr.innerHTML; //获取html的内容
      let htmlStr = `
      <!DOCTYPE html>
      <html lang="en">
        <body>
          ${html}
        </body>
      </html>`; //把获取到的html放入到原生的html中
      saveAs(htmlDocx.asBlob(htmlStr, { orientation: 'landscape' }), '付款通知书.doc'); // 导出为word
    },
    //关闭打印
    closePrint() {
      this.$emit('closePrint');
    },
    billPrintClick() {
      const style = '@page {margin:0 10mm}' //打印时去掉眉页眉尾
      printJS({
        printable: 'printBillxx'+this.printType, // 标签元素id
        type: 'html',
        // header: '',
        // documentTitle: str,
        targetStyles: ['*'],
        // scanStyles: true,
        style
      });
      //各个配置项
      //printable:要打印的id。
      //type:可以是 html 、pdf、 json 等。
      //properties:是打印json时所需要的数据属性。
      //gridHeaderStyle和gridStyle都是打印json时可选的样式。
      //repeatTableHeader:在打印JSON数据时使用。设置为时false，数据表标题将仅在第一页显示。
      //scanStyles:设置为false时，库将不处理应用于正在打印的html的样式。使用css参数时很有用，此时自己设置的原来想要打印的样式就会失效，在打印预览时可以看到效果
      //targetStyles: [’*’],这样设置继承了页面要打印元素原有的css属性。
      //style:传入自定义样式的字符串，使用在要打印的html页面 也就是纸上的样子。
      //ignoreElements：传入要打印的div中的子元素id，使其不打印。非常好用
     // this.closePrint();
    },
    // 处理数据
    caCodeToDesc(listStr) {
      if (listStr != '') {
        listStr = listStr
          .replace(/\"/g, '')
          .replace(/[\\]/g, '')
          .replace(/\[/g, '')
          .replace(/\]/g, '')
          .replace(/\,/g, '；');
        console.log(listStr);
        return listStr;
      }
    },
    changeEnter(content) {
      if (content == '' || content == null) {
        return '无';
      } else {
        content = content.replace(/\n/g, '</br>');
        return content;
      }
    },
  },
};
</script>
